"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getOperations = void 0;
var network_1 = __importDefault(require("../../../network"));
var querystring_1 = __importDefault(require("querystring"));
var bignumber_js_1 = require("bignumber.js");
var operation_1 = require("../../../operation");
var env_1 = require("../../../env");
var common_1 = require("./common");
var address_1 = require("../address");
var LIMIT = 200;
/**
 * Return the url of the indexer
 *
 * @returns {string}
 */
var getBaseApiUrl = function () { return (0, env_1.getEnv)("API_POLKADOT_INDEXER"); };
/**
 * Fetch operation lists from indexer
 *
 * @param {string} addr
 * @param {number} offset
 * @param {number} startAt
 * @param {number} limit
 *
 * @returns {string}
 */
var getAccountOperationUrl = function (addr, offset, startAt, limit) {
    if (limit === void 0) { limit = LIMIT; }
    return "".concat(getBaseApiUrl(), "/accounts/").concat(addr, "/operations?").concat(querystring_1["default"].stringify({
        limit: limit,
        offset: offset,
        startAt: startAt
    }));
};
var getWithdrawUnbondedAmount = function (extrinsic) {
    var _a;
    return (((_a = extrinsic === null || extrinsic === void 0 ? void 0 : extrinsic.staking) === null || _a === void 0 ? void 0 : _a.eventStaking.reduce(function (acc, curr) {
        return curr.method === "Withdrawn"
            ? new bignumber_js_1.BigNumber(acc).plus(curr.value)
            : new bignumber_js_1.BigNumber(0);
    }, new bignumber_js_1.BigNumber(0))) || new bignumber_js_1.BigNumber(0));
};
var getController = function (_extrinsic) {
    // TODO: ask BisonTrails to provide the info
    return "";
};
/**
 * add Extra info for operation details
 *
 * @param {OperationType} type
 * @param {*} extrinsic
 *
 * @returns {Object}
 */
var getExtra = function (type, extrinsic) {
    var _a, _b, _c;
    var extra = {
        palletMethod: "".concat(extrinsic.section, ".").concat(extrinsic.method)
    };
    switch (type) {
        case "IN":
        case "OUT":
            if (extrinsic.amount || extrinsic.amount === 0) {
                extra = __assign(__assign({}, extra), { transferAmount: new bignumber_js_1.BigNumber(extrinsic.amount) });
            }
            break;
        case "BOND":
            if (extrinsic.amount || extrinsic.amount === 0) {
                extra = __assign(__assign({}, extra), { bondedAmount: new bignumber_js_1.BigNumber(extrinsic.amount) });
            }
            break;
        case "UNBOND":
            if (extrinsic.amount || extrinsic.amount === 0) {
                extra = __assign(__assign({}, extra), { unbondedAmount: new bignumber_js_1.BigNumber(extrinsic.amount) });
            }
            break;
        case "WITHDRAW_UNBONDED":
            extra = __assign(__assign({}, extra), { withdrawUnbondedAmount: getWithdrawUnbondedAmount(extrinsic) });
            break;
        case "SET_CONTROLLER":
            extra = __assign(__assign({}, extra), { controller: getController(extrinsic) });
            break;
        case "REWARD_PAYOUT":
        case "SLASH":
            extra = __assign(__assign({}, extra), { validatorStash: extrinsic.validatorStash, amount: new bignumber_js_1.BigNumber(extrinsic.value) });
            break;
        case "NOMINATE":
            extra = __assign(__assign({}, extra), { validators: (_c = (_b = (_a = extrinsic.staking) === null || _a === void 0 ? void 0 : _a.validators) === null || _b === void 0 ? void 0 : _b.reduce(function (acc, current) {
                    return __spreadArray(__spreadArray([], __read(acc), false), [current.address], false);
                }, [])) !== null && _c !== void 0 ? _c : [] });
            break;
    }
    return extra;
};
/**
 * Returns the operation value (amount if relevant + fees) depending on type
 *
 * @param {*} extrinsic
 * @param {OperationType} type
 *
 * @returns {BigNumber}
 */
var getValue = function (extrinsic, type) {
    if (!extrinsic.isSuccess) {
        return type === "IN"
            ? new bignumber_js_1.BigNumber(0)
            : new bignumber_js_1.BigNumber(extrinsic.partialFee || 0);
    }
    switch (type) {
        case "OUT":
            return extrinsic.signer !== extrinsic.affectedAddress1
                ? new bignumber_js_1.BigNumber(extrinsic.amount).plus(extrinsic.partialFee)
                : new bignumber_js_1.BigNumber(extrinsic.partialFee);
        case "IN":
        case "SLASH":
            return new bignumber_js_1.BigNumber(extrinsic.amount);
        default:
            return new bignumber_js_1.BigNumber(extrinsic.partialFee);
    }
};
/**
 * Map extrinsic into the live operation type
 *
 * @param {string} addr
 * @param {string} accountId
 * @param {*} extrinsic
 *
 * @returns {Operation | null}
 */
var extrinsicToOperation = function (addr, accountId, extrinsic) {
    var type = (0, common_1.getOperationType)(extrinsic.section, extrinsic.method);
    if (type === "OUT" &&
        extrinsic.affectedAddress1 === addr &&
        extrinsic.signer !== addr) {
        type = "IN";
    }
    if (type !== "IN" && extrinsic.signer !== addr) {
        return null;
    }
    return {
        id: (0, operation_1.encodeOperationId)(accountId, extrinsic.hash, type),
        accountId: accountId,
        fee: new bignumber_js_1.BigNumber(extrinsic.partialFee || 0),
        value: getValue(extrinsic, type),
        type: type,
        hash: extrinsic.hash,
        blockHeight: extrinsic.blockNumber,
        date: new Date(extrinsic.timestamp),
        extra: getExtra(type, extrinsic),
        senders: [extrinsic.signer],
        recipients: [extrinsic.affectedAddress1, extrinsic.affectedAddress2]
            .filter(Boolean)
            .filter(address_1.isValidAddress),
        transactionSequenceNumber: extrinsic.signer === addr ? extrinsic.nonce : undefined,
        hasFailed: !extrinsic.isSuccess
    };
};
/**
 * Map reward to live operation type
 *
 * @param {string} addr
 * @param {string} accountId
 * @param {*} reward
 *
 * @returns {Operation | null}
 */
var rewardToOperation = function (addr, accountId, reward) {
    var hash = reward.extrinsicHash;
    var type = "REWARD_PAYOUT";
    return {
        id: (0, operation_1.encodeOperationId)(accountId, "".concat(hash, "+").concat(reward.index), type),
        accountId: accountId,
        fee: new bignumber_js_1.BigNumber(0),
        value: new bignumber_js_1.BigNumber(reward.value),
        type: type,
        hash: hash,
        blockHeight: reward.blockNumber,
        date: new Date(reward.timestamp),
        extra: getExtra(type, reward),
        senders: [reward.validatorStash].filter(Boolean),
        recipients: [reward.accountId].filter(Boolean)
    };
};
/**
 * Map slash to live operation type
 *
 * @param {string} addr
 * @param {string} accountId
 * @param {*} slash
 *
 * @returns {Operation | null}
 */
var slashToOperation = function (addr, accountId, slash) {
    var hash = "".concat(slash.blockNumber);
    var type = "SLASH";
    return {
        id: (0, operation_1.encodeOperationId)(accountId, "".concat(hash, "+").concat(slash.index), type),
        accountId: accountId,
        fee: new bignumber_js_1.BigNumber(0),
        value: new bignumber_js_1.BigNumber(slash.value),
        type: type,
        hash: hash,
        blockHeight: slash.blockNumber,
        senders: [slash.validatorStash].filter(Boolean),
        recipients: [slash.accountId].filter(Boolean),
        date: new Date(slash.timestamp),
        extra: getExtra(type, slash)
    };
};
/**
 * Fetch loop with multiple operations per page / offsite / start
 *
 * @param {string} accountId
 * @param {string} addr
 * @param {number} startAt
 * @param {number} offset
 *
 * @param {Operation[]} prevOperations
 */
var fetchOperationList = function (accountId, addr, startAt, offset, prevOperations) {
    if (offset === void 0) { offset = 0; }
    if (prevOperations === void 0) { prevOperations = []; }
    return __awaiter(void 0, void 0, void 0, function () {
        var data, operations, rewards, slashes, mergedOp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, network_1["default"])({
                        method: "GET",
                        url: getAccountOperationUrl(addr, offset, startAt)
                    })];
                case 1:
                    data = (_a.sent()).data;
                    operations = data.extrinsics.map(function (extrinsic) {
                        return extrinsicToOperation(addr, accountId, extrinsic);
                    });
                    rewards = data.rewards.map(function (reward) {
                        return rewardToOperation(addr, accountId, reward);
                    });
                    slashes = data.slashes.map(function (slash) {
                        return slashToOperation(addr, accountId, slash);
                    });
                    mergedOp = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(prevOperations), false), __read(operations), false), __read(rewards), false), __read(slashes), false);
                    if (operations.length < LIMIT &&
                        rewards.length < LIMIT &&
                        slashes.length < LIMIT) {
                        return [2 /*return*/, mergedOp.filter(Boolean).sort(function (a, b) { return b.date - a.date; })];
                    }
                    return [4 /*yield*/, fetchOperationList(accountId, addr, startAt, offset + LIMIT, mergedOp)];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
};
/**
 * Fetch all operations for a single account from indexer
 *
 * @param {string} accountId
 * @param {string} addr
 * @param {number} startAt - blockHeight after which you fetch this op (included)
 *
 * @return {Operation[]}
 */
var getOperations = function (accountId, addr, startAt) {
    if (startAt === void 0) { startAt = 0; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchOperationList(accountId, addr, startAt)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
};
exports.getOperations = getOperations;
//# sourceMappingURL=bisontrails.js.map